export const oldIconMapper = {
  "angle-left-light": {
    name: "angle-left",
    weight: "light",
    width: "21px",
    height: "21px",
  },
  "angle-right-light": {
    name: "angle-right",
    weight: "light",
    width: "21px",
    height: "21px",
  },
  "arrow-right-solid": {
    name: "arrow-right",
    weight: "solid",
    width: "11px",
    height: "11px",
  },
  "arrow-left-solid": {
    name: "arrow-left",
    weight: "solid",
    width: "11px",
    height: "11px",
  },
  "star-light": {
    name: "star",
    weight: "light",
    width: "17px",
    height: "16px",
  },
  "star-solid": {
    name: "star",
    weight: "solid",
    width: "17px",
    height: "16px",
  },
  "sticky-note-regular": {
    name: "sticky-note",
    weight: "regular",
    width: "16px",
    height: "16px",
  },
  "sticky-note-solid": {
    name: "sticky-note",
    weight: "solid",
    width: "16px",
    height: "16px",
  },
};
